import {apiVoissaNoError} from "../../libs/api";

export const fetchUserTests = () => {
    return  apiVoissaNoError.get(`/ab-service/user-tests`);
};

export const AB_SERVICE_USER_TESTS = `AB_SERVICE_USER_TESTS`;
